import { COOKIES } from '#shared/constants/cookies'

export default defineNuxtPlugin({
  name: 'experiment',
  async setup() {
    const { $captureError } = useNuxtApp()
    const runtimeConfig = useRuntimeConfig()
    const requestFetch = useRequestFetch()

    const { userEmail, userId, userIsOwner, userLocale } = useUser()
    const { userAgent, isMobile, isTablet, isDesktop } = useDevice()
    const { geolocation } = useGeolocation()
    const sessionId = useCookie(COOKIES.session)
    const UserDevice = isMobile ? 'mobile' : isTablet ? 'tablet' : isDesktop ? 'desktop' : 'unknown'
    const experimentsConfig = useExperimentsConfig()

    if (isMetaServer) {
      if (isMetaDev) {
        console.log('[plugin: server] - experiments 🧪')
      }

      await evaluateExperiments()
    }

    async function evaluateExperiments() {
      try {
        const experiments = await requestFetch('/api/experiments', {
          method: 'POST',
          body: {
            email: userEmail.value,
            country: geolocation.value?.countryCode ?? null,
            custom: {
              UserId: userId.value.toString(),
              SessionId: sessionId.value,
              UserAgent: userAgent,
              UserDevice,
              Language: userLocale.value,
              IsOwner: userIsOwner.value ? 'yes' : 'no',
              EnvironmentName: runtimeConfig.public.hostEnvironment,
              Region: geolocation.value?.regionCode ?? null,
            },
          },
        })

        experimentsConfig.value = experiments
      }
      catch (error) {
        $captureError(error)
        experimentsConfig.value = {}
      }
    }

    const overridesCookie = useCookie(COOKIES.experimentOverrides, {
      domain: runtimeConfig.public.cookieDomain,
      path: '/',
    })

    watch(overridesCookie, async () => {
      await evaluateExperiments()
    })

    return {
      provide: {
        experiment: {
          evaluateExperiments,
        },
      },
    }
  },
})
